export default {
  autoComplete: '/admin/api/thirdparties/third-parties-auto-complete',
  data: '/admin/api/thirdparties',
  thatWouldBeAffected: '/admin/api/thirdparties/users-third-parties-that-would-be-affected'
};
